import { BankDto } from '@core/service/digital-factory/bank/types/bankDto';

export class BankChoiceVM {
  findMostPopularBanks(allBanks: BankDto[]): BankDto[] {
    const numberOfPopularBanksDisplayed = 9;

    const mostPopularBankNamesOrdered = [
      "Caisse d'Épargne Particuliers",
      'Banque Populaire',
      'Société Générale',
      'La Banque Postale',
      'LCL',
      'BNP Paribas',
      'Crédit Agricole',
      'BoursoBank',
      'CIC',
      'Crédit Mutuel',
      'Hello bank!',
      'Banque Européenne Crédit Mutuel',
      'Crédit Mutuel de Bretagne',
      'Fortuneo',
      'Monabanq',
      'Crédit Mutuel du Sud Ouest',
      'BforBank',
      'Carrefour Banque',
    ];

    const popularBanksAvailable = this.filterAndSortBanks(allBanks, mostPopularBankNamesOrdered);
    return popularBanksAvailable.slice(0, numberOfPopularBanksDisplayed);
  }

  private filterAndSortBanks(banks: BankDto[], namesOfBankToRetrieve: string[]): BankDto[] {
    return banks
      .filter((bank) => namesOfBankToRetrieve.includes(bank.name))
      .sort((a, b) => {
        const indexA = namesOfBankToRetrieve.indexOf(a.name);
        const indexB = namesOfBankToRetrieve.indexOf(b.name);
        return indexA - indexB;
      });
  }
}
